import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, checked } = useAuth();
    if (!checked) {
        return (
            <div className="min-h-screen flex items-center justify-center text-zinc-500" data-testid="auth-loading">
                <div className="h-6 w-6 rounded-full border border-zinc-700 border-t-[#D4AF37] animate-spin" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
